const froalaAndAccordionContentTables = document.querySelectorAll('.fr-view table, .accordion-item__content table');

const wrap = toWrap => {
    const wrapper = document.createElement('div');
    const nextSibling = toWrap.nextSibling;

    wrapper.classList.add('table-wrapper');
    toWrap.parentNode.insertBefore(wrapper, nextSibling);
    return wrapper.appendChild(toWrap);
};

if (froalaAndAccordionContentTables.length) {
    [].forEach.call(froalaAndAccordionContentTables, table => {
        wrap(table);
    })
}